import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

const AboutPage = () => {
    return (
        <div className="about-container">
            <header className="about-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <div className="about-content">
                <h2>About Me</h2>
                
                <p>
                    My name is Sercihan Said Gökçenoğlu. I'm a software engineer - or at least trying to be one. 
                    I enjoy building things, solving problems, and constantly learning.
                </p>
                
                <p>
                    This blog is where I share my thoughts on the things I experience in life and anything that 
                    happens to capture my interest.
                </p>
                
                <p>
                    Feel free to reach out at <a href="mailto:sercihan7@gmail.com">sercihan7@gmail.com</a>. 
                    I'm always happy to meet new people. While I can't promise a reply to every message, 
                    I'll do my best to respond when I can.
                </p>
                
                <p className="about-note">
                    (Also known as SSG, and formerly one of the best upcoming in-game leaders of competitive 
                    gaming - or so I like to believe.)
                </p>
                
                <h3>Find me on</h3>
                
                <ul className="about-links">
                    <li>
                        <a href="https://linkedin.com/in/sercihan" target="_blank" rel="noopener noreferrer">
                            LinkedIn
                        </a>
                    </li>
                    <li>
                        <a href="https://x.com/sercihanakassg" target="_blank" rel="noopener noreferrer">
                            X (Twitter)
                        </a>
                    </li>
                    <li>
                        <a href="https://letterboxd.com/ssg007/" target="_blank" rel="noopener noreferrer">
                            Letterboxd
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/sercihanakassg/" target="_blank" rel="noopener noreferrer">
                            Instagram
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default AboutPage;
